import { render, staticRenderFns } from "./shopSetting.vue?vue&type=template&id=57397868&scoped=true&"
import script from "./shopSetting.vue?vue&type=script&lang=js&"
export * from "./shopSetting.vue?vue&type=script&lang=js&"
import style0 from "./shopSetting.vue?vue&type=style&index=0&id=57397868&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57397868",
  null
  
)

export default component.exports